/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './physio-category-item.reducer';

export const PhysioCategoryItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const physioCategoryItemEntity = useAppSelector(state => state.physioCategoryItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="physioCategoryItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.physioCategoryItem.detail.title">PhysioCategoryItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.physioCategoryItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{physioCategoryItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.physioCategoryItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{physioCategoryItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.physioCategoryItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{physioCategoryItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.physioCategoryItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{physioCategoryItemEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.physioCategoryItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{physioCategoryItemEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.physioCategoryItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{physioCategoryItemEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/physio-category-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/physio-category-item/${physioCategoryItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PhysioCategoryItemDetail;
